export default __webpack_public_path__ + "static/glass-6ac7830664209b40cb4a9d3c7ab0a080.png";